var render = function render(){var _vm=this,_c=_vm._self._c;return _c('object',{ref:"mapa",staticStyle:{"width":"100%","height":"calc(100% - 0.75rem)"},attrs:{"id":"mapa-zoom-area","data":_vm.mapaUrl,"type":"image/svg+xml"},on:{"load":_vm.onLoad}})
}
var staticRenderFns = []

export { render, staticRenderFns }